/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatisticByCategoryList } from '../../models/statistic-by-category-list';

export interface StatisticsByCategory$Params {
}

export function statisticsByCategory(http: HttpClient, rootUrl: string, params?: StatisticsByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<StatisticByCategoryList>> {
  const rb = new RequestBuilder(rootUrl, statisticsByCategory.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatisticByCategoryList>;
    })
  );
}

statisticsByCategory.PATH = '/custom/stations/statisticsByCategory';
